import { IContactPermission } from "@interface/customerDetails/ICustomerDetails";

import {
    EPermissions,
    IMarketingPreferencesForm,
    IPermissionNameValue,
} from "@features/customerDetails/ICustomerDetailsForm";
import { ACTIVE_CUSTOMER, ALLOW_3RD_PARTIES, NO_LONGER_CUSTOMER } from "@constants";

export const mapMarketingPreferencesForm = (response: IContactPermission): IMarketingPreferencesForm => {
    const defaultPermissions: IPermissionNameValue = {
        ALLOW_EMAIL_CONTACT: false,
        ALLOW_SMS_CONTACT: false,
        ALLOW_PHONE_CONTACT: false,
        ALLOW_DIRECT_MAIL_CONTACT: false,
    };

    const contactPermissionForm: IMarketingPreferencesForm = {
        allowThirdParty: { ...defaultPermissions },
        noLongerCustomer: { ...defaultPermissions },
        activeCustomer: { ...defaultPermissions },
    };

    response.permissionGroups.forEach((permissionGroup) => {
        const permissionsMap: IPermissionNameValue = { ...defaultPermissions };

        permissionGroup.permissions
            .filter((permission) => permission.name !== "FOTS")
            .forEach((permission) => {
                permissionsMap[permission.permission as EPermissions] = permission.enabled;
            });

        if (permissionGroup.permissionGroup === ACTIVE_CUSTOMER) {
            contactPermissionForm.activeCustomer = permissionsMap;
        } else if (permissionGroup.permissionGroup === NO_LONGER_CUSTOMER) {
            contactPermissionForm.noLongerCustomer = permissionsMap;
        } else if (permissionGroup.permissionGroup === ALLOW_3RD_PARTIES) {
            contactPermissionForm.allowThirdParty = permissionsMap;
        }
    });

    return contactPermissionForm;
};
